import {memo} from 'react';
import {any, number} from 'prop-types';
import {styled} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import {regular} from 'r/Design';
import WithHoverTooltip from 'r/ui/WithHoverTooltip';
import helpSvg from 'r/icons/help-circle.svg';


const Wr = styled.div`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  position: relative;
  margin-left: ${props => props.$marginLeft}px;
  margin-right: ${props => props.$marginRight}px;
  display: flex;
  align-items: center;
  ${regular}
  &::before {
    position: relative;
    content: '';
    display: inline-block;
    width: 100%;
    height: 100%;
    background-image: url("${helpSvg}");
    background-size: cover;
  }
`;


export default memo(QuestionTooltip);

QuestionTooltip.propTypes = forbidExtraProps({
  content: any.isRequired,
  marginLeft: number,
  marginRight: number,
  size: number.isRequired,
});

function QuestionTooltip({
  content,
  marginLeft,
  marginRight,
  size,
}) {

  return (
    <WithHoverTooltip
      element={
        <Wr
          $marginLeft={marginLeft}
          $marginRight={marginRight}
          $size={size}
        />
      }
      tooltipContent={content}
    />
  );
}
